import { useState } from 'react';
import { Link } from 'react-router-dom';
import { assetApi, type Asset } from '../../api/media';

export function AssetSearchPage() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<Asset[]>([]);
  const [loading, setLoading] = useState(false);

  async function search(e: React.FormEvent) {
    e.preventDefault();
    if (!query.trim()) return;
    setLoading(true);
    try {
      const res = await assetApi.search(query.trim());
      setResults(res.results ?? []);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/media" className="text-sm text-slate-600 hover:underline">← Library</Link>
      <h1 className="mt-4 text-2xl font-semibold">Media Search</h1>
      <form onSubmit={(e) => void search(e)} className="mt-6 flex gap-3">
        <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search assets…" className="flex-1 rounded-lg border px-3 py-2" />
        <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Search</button>
      </form>
      {loading ? <p className="mt-6">Searching…</p> : (
        <ul className="mt-6 space-y-3">
          {results.map((a) => (
            <li key={a.id} className="rounded-xl border bg-white p-4">
              <Link to={`/media/assets/${a.id}`} className="font-medium hover:underline">{a.name}</Link>
              <p className="text-sm text-slate-500">{a.type} · {a.status}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
